import { FeatureFlagName } from "../../../mp-utils/generic-utils/feature-flags/types"
import { DetailsDataProviderConfigType } from "./types"

export const QUERY_DETAILS_DATA_KEY = "DETAILS-DATA-KEY"

export const DETAILS_DATA_PROVIDER_CONFIG: Record<
  string,
  Record<string, DetailsDataProviderConfigType>
> = {
  "teaching-tools": {
    assignments: {
      dataSource: "graphql"
    },
    "test-administration": {
      dataSource: "graphql"
    }
  },
  organization: {
    states: {
      dataSource: "graphql",
      graphqlFeatureFlag: FeatureFlagName.reporting_graphql_organization_states
    },
    districts: {
      dataSource: "graphql",
      graphqlFeatureFlag:
        FeatureFlagName.reporting_graphql_organization_districts
    },
    schools: {
      dataSource: "graphql",
      graphqlFeatureFlag: FeatureFlagName.reporting_graphql_organization_schools
    },
    admins: {
      dataSource: "graphql",
      graphqlFeatureFlag: FeatureFlagName.reporting_graphql_organization_admins
    },
    teachers: {
      dataSource: "graphql",
      graphqlFeatureFlag: FeatureFlagName.reporting_graphql_organization_teachers
    },
    classes: {
      dataSource: "graphql",
      graphqlFeatureFlag: FeatureFlagName.reporting_graphql_organization_classes
    },
    students: {
      dataSource: "graphql",
      graphqlFeatureFlag:
        FeatureFlagName.reporting_graphql_organization_students
    }
  }
}
